@if (isActivePlay) {
  <div
    class="video-player-fullscreen is-playing"
    [style]="previewStyleObject"
    [class.webview-hack]="needWebViewHack"
    (mousemove)="hideHeaderTimerExecute()"
  >
    <div class="header" [class.hidden]="hiddenFullscreenHeader">
      <div class="title">{{ title }}</div>
      <div (click)="closeVideoPlayer()" class="cancel argo-icon-cancel"></div>
    </div>
    @if (streamUrl) {
      <app-stream [activatePlay]="isActivePlay" [streamUrl]="streamUrl" class="argo-stream"></app-stream>
    }
  </div>
}
